<template>
  <div class="userList">
    <HearderTitle name="人员管理" />
    <div class="tableBox">
      <div class="tool_bar">
        <el-form :inline="true">
          <el-form-item label="用户名" prop="username" class="middle" style="padding-left: 10px; padding-right: 20px">
            <el-input type="text" v-model="searchData.username" clearable placeholder="请输入用户名"></el-input>
          </el-form-item>
          <el-form-item label="项目" prop="departments" class="middle">
            <el-select v-model="searchData.departments" placeholder="请选择项目">
              <el-option v-for="(item, index) in depList" :key="index" :label="item.dname" :value="String(item.did)"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button class="lightBlueBtn" type="primary" size="small" @click="getuserList()" style="margin-left: 15px">搜索</el-button>
          </el-form-item>
          <el-form-item style="float: right">
            <el-button class="lightBlueBtn" type="primary" size="small" @click="add()">添加管理员</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table">
        <el-table ref="refTable" header-cell-class-name="h_bg" :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="ID号" width="180" align="center"> </el-table-column>
          <el-table-column prop="username" label="用户名" align="center"> </el-table-column>
          <el-table-column prop="nickname" label="昵称" align="center"> </el-table-column>
          <el-table-column prop="" label="项目" align="center">
            <template slot-scope="scope">
              <span v-for="item in getDepNames(scope.row.deps)" :key="item.id" style="margin-right: 2px"> {{ item.dname }} </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="258">
            <template slot-scope="scope">
              <div class="table_btns">
                <el-button @click="show(scope.row)" size="mini">编辑</el-button>
                <el-button size="mini" @click="$router.push({ name: 'editPermission', params: { id: scope.row.id } })" class="warning max">权限管理</el-button>
                <el-button size="mini" @click="del(scope.row.id)" class="warning">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog class="userDialog" ref="userDialog" :modal="false" :title="userDialogTitle" @close="closeDialig()" :visible.sync="userDialog" width="435px">
      <el-form ref="user" :rules="rules" :model="userData" label-width="80px">
        <el-form-item v-if="userDialogTitle === '新增用户'" label="账号" prop="username">
          <el-input type="text" v-model="userData.username" autofocus></el-input>
        </el-form-item>
        <el-form-item label="昵称" prop="nickname">
          <el-input type="text" v-model="userData.nickname" autofocus></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="userData.password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="rePassword">
          <el-input type="password" v-model="userData.rePassword"></el-input>
        </el-form-item>

        <el-form-item label="项目" prop="departments" class="departments">
          <!-- 按钮组一行三个 -->
          <el-checkbox-group v-model="userData.departments" style="width: 100%; display: flex; flex-wrap: wrap">
            <el-checkbox v-for="(item, index) in depList" :key="index" :label="String(item.did)" style="width: 33%; margin-right: 50px">
              {{ item.dname }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item>
          <input type="text" v-model="userData.id" hidden />
          <el-button class="lightBlueBtn searchBtn" type="primary" size="small" @click="seve()">提交</el-button>
          <!-- 取消关闭弹窗 -->
          <el-button size="small" plain class="searchBtn" @click="userDialog = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import { addUser, deleteUser, editUser, userList } from '@/api/user.js'
  import HearderTitle from '@/components/HearderTitle'
  import { depList } from '../../api/user'
  export default {
    name: 'userList',
    data() {
      const validatePass2 = (rule, value, callback) => {
        if (value !== this.userData.password) {
          callback(new Error('两次输入密码不一致!'))
        } else {
          callback()
        }
      }
      return {
        searchData: {
          username: '',
          departments: '',
        },
        userDialogTitle: '新增用户',
        tableData: [],
        userDialog: false,
        depList: [],
        userData: {
          nickname: '',
          id: '',
          password: '',
          rePassword: '',
          username: '',
          departments: [], // 新增字段
        },
        rules: {
          nickname: [{ required: true, message: '昵称不能为空', trigger: 'blur' }],
          username: [
            {
              required: false,
              message: '请输入用户名',
              trigger: 'blur',
            },
            {
              min: 2,
              max: 12,
              message: '长度在 2 到 12 个字符',
              trigger: 'blur',
            },
            { required: false, message: '账号不能为空', trigger: 'blur' },
          ],
          password: [
            {
              min: 6,
              max: 15,
              message: '长度在 6 到 15 个字符',
              trigger: 'blur',
            },
            { required: false, message: '密码不能为空', trigger: 'blur' },
          ],
          rePassword: [
            { required: false, message: '确认密码不能为空', trigger: 'blur' },
            { validator: validatePass2, trigger: 'blur' },
          ],
          departments: [{ required: true, message: '请选择至少一个项目', trigger: 'change' }], // 新增验证规则
        },
      }
    },
    created() {
      this.getuserList()
      this.getDepList()
    },
    components: { HearderTitle },
    methods: {
      // 获取人员列表
      async getuserList() {
        let { plist } = await userList(this.searchData)
        this.tableData = plist
      },
      add() {
        this.userDialogTitle = '新增用户'
        this.userDialog = true
      },
      // 获取项目列表
      async getDepList() {
        let res = await depList()
        this.depList = res.list
      },
      getDepNames(departmentStr) {
        if (!departmentStr) return []
        const ids = departmentStr.split(',').map((id) => Number(id))
        return this.depList.filter((dep) => ids.includes(dep.did))
      },
      // 删除人员
      async del(id) {
        if (!id) return this.$message.error('请选择要删除的数据')
        this.$customConfirm({
          title: '提示',
          content: '您确定删除该用户吗？',
          confirmText: '确定',
          cancelText: '取消',
          onConfirm: async () => {
            let response = await deleteUser({ id })
            if (response.status !== 200) {
              this.$message.error('删除失败')
            } else {
              this.$message.success('删除成功')
              // 删除成功后刷新页面
              this.getuserList()
            }
          },
          onCancel: () => {
            this.$message.info('取消成功')
          },
        })
      },
      // 显示修改状态弹窗
      show(data) {
        this.userDialogTitle = '修改人员'
        this.userData.nickname = data.nickname
        this.userData.id = data.id
        this.userData.departments = data.deps ? data.deps.split(',') : [] // 赋值项目
        this.userData.departments
        this.userDialog = true
      },
      async seve() {
        this.$refs['user'].validate(async (valid) => {
          if (!valid) return
          let res = {}
          let { nickname, password, id, departments } = this.userData
          departments = departments.join(',')

          if (this.userData.id === '') {
            res = await addUser({ nickname, password, id, username: this.userData.username, deps: departments })
          } else {
            if (password) {
              res = await editUser({ nickname, password, id, departments })
            } else {
              res = await editUser({ nickname, id, departments })
            }

            this.userData.nickname = ''
            this.userData.departments = []
            this.userData.id = ''
          }
          if (res.status !== 200) return this.$message.error(res.msg)
          this.$message.success('提交成功')
          this.closeDialig()
          this.$refs['user'].resetFields()
          this.userDialog = false
          return this.getuserList()
        })
      },
      closeDialig() {
        this.userData.nickname = ''
        this.userData.id = ''
        this.userData.username = ''
        this.userData.rePassword = ''
      },
    },
  }
</script>

<style lang="less">
  .userList {
    .tableBox {
      .table .table_btns .el-button.max {
        width: 68px;
      }
      .select {
        color: #015293;
        font-size: 12px;
        cursor: pointer;
      }
      .tool_bar {
        overflow: hidden;
        padding-top: 18px;
        padding-bottom: 18px;
        font-size: 14px;
        color: #888;
        .el-form-item {
          margin-right: 0;
          margin-bottom: 0;
          .el-input__inner {
            width: 210px;
            height: 32px;
          }
          .el-input__inner {
            padding-left: 10px;
          }
          .middle {
            padding: 0 10px;
          }
          .searchBtn {
            width: 82px;
          }
        }
      }
      .el-table {
        min-height: 685px;
        &::before {
          height: 0;
        }
      }
    }
  }
  .userDialog {
    .el-dialog__header {
      border-bottom: 1px solid #dcdfe6;
    }
    .el-dialog__body {
      padding-bottom: 0;
      overflow: hidden;
      .el-form-item {
        margin-bottom: 20px;
      }
    }
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner,
    .el-textarea__inner {
      width: 300px;
    }
    .el-input__inner {
      padding-left: 15px;
      width: 300px;
    }
    .searchBtn {
      width: 112px;
    }
  }
</style>
